const types = {
  changeLocale: 'appSettings/changeLocale',
  submitInquiry: 'inquiry/submitInquiry'
}

export default types
